export default __webpack_public_path__ + "static/media/oliver-peoples-7.71af4c8d.png";